<template>
  <div class="yxtbiz-open-download-tool">
    <yxt-dialog
      padding-size="small"
      :visible.sync="dialogVisible"
      ref="dialog"
      width="440px"
      class="yxtbiz-open-download-tool_dialog"
      :show-close="false"
      append-to-body
      destroy-on-close
      @close="handleCancel"
    >
      <div class="yxtbiz-open-download-tool_dialog-title">
        <yxt-svg
          color="#F5222D"
          width="20px"
          height="20px"
          icon-class="message-warning"
        />
        <span class="ml12 standard-size-16 text-26 yxtf-weight-5">
          {{
            callStatus === 'opening'
              ? $t('pc_biz_openmili').d('正在打开米粒客户端') + '...'
              : $t('pc_biz_openmili_fail').d('未打开米粒客户端')
          }}</span
        >
      </div>
      <div class="mt8 ml32">
        {{
          callStatus === 'opening'
            ? $t('pc_biz_openmili_tip').d(
                '若长时间未打开请确认是否安装米粒客户端，若未安装，请下载安装。'
              )
            : $t('pc_biz_openmilifail_tip').d(
                '请点击浏览器弹框显示的打开米粒，若未看到浏览器弹框，请点击启动米粒或下载米粒客户端。'
              )
        }}
      </div>
      <div class="mt24 yxtbiz-open-download-tool_dialog-footer">
        <yxt-button @click="dialogVisible = false">{{
          $t('pc_comp_messagebox_cancel')
        }}</yxt-button>
        <yxt-button v-if="callStatus === 'fail'" @click="handleRetry">{{
          $t('pc_biz_startmili').d('启动米粒')
        }}</yxt-button>
        <yxt-button type="primary" @click="handleDownload">{{
          $t('pc_biz_download_mili').d('下载米粒客户端')
        }}</yxt-button>
      </div>
    </yxt-dialog>
  </div>
</template>

<script>
import { apiEnv } from '../../api/configDomain';
import {
  saveMiliStartStatus,
  checkMiliStartStatus,
  getMiliUrl,
  getDownStatus
} from '../service';
import { createUuid, openUriWithHiddenFrame } from '../utils';
import browser from '../browser';
import dayjs from 'dayjs';

export default {
  name: 'YxtbizOpenDownloadTool',
  name_zh: '启动米粒',
  data() {
    return {
      callStatus: '', // 唤起状态
      dialogVisible: false,
      uuid: '',
      timeout: 30, // 超时时间30s
      timer: null,
      alertable: false,
      openTime: '',
      downFrequency: 0
    };
  },
  eventList: [],
  slots: [],
  props: {
    // 默认定位的页面 upload：上传， download：下载
    page: {
      type: String,
      default: 'upload',
      desc: '默认定位的页面',
      setter: 'TabSetter',
      enums: [
        {
          label: 'upload',
          value: '上传'
        },
        {
          label: 'download',
          value: '下载'
        }
      ]
    },
    // 业务方标识
    module: {
      type: String,
      default: '',
      require: true,
      desc: '业务方标识',
      setter: 'StringSetter'
    },
    // 下载任务ID
    downTaskId: {
      type: String,
      default: '',
      desc: '下载任务ID',
      setter: 'StringSetter'
    }
  },
  methods: {
    open(type) {
      type !== 'retry' &&
        (this.openTime = dayjs().format('YYYY-MM-DD HH:mm:ss'));
      // 判断是否在pc端微信/企业微信浏览器中
      // const ua = navigator.userAgent.toLowerCase();
      // const isBrowserInWeixin =
      //   ua.indexOf('macwechat') > -1 || ua.indexOf('windowswechat') > -1;
      // if (isBrowserInWeixin) {
      //   location.href = `${location.protocol}//${
      //     location.hostname
      //   }/tlive/#/browser?origin=${encodeURIComponent(location.href)}`;
      //   return;
      // }

      // if (browser.mac && isDd()) {
      //   this.macTip();
      //   return;
      // }
      this.callStatus = 'opening';
      this.dialogVisible = true;

      if (this.page === 'download' && this.downTaskId) {
        this.downFrequency = 0;
        this.checkDownStatus();
      } else {
        this.initData();
      }
    },
    // 轮询检测下载任务是否生成成功
    checkDownStatus() {
      if (this.downFrequency >= 10) {
        this.dialogVisible = false;
        this.$confirm(
          this.$t('pc_biz_mili_downfailTip').d('获取下载信息失败！'),
          this.$t('pc_biz_lbl_tip'),
          {
            confirmButtonText: this.$t('pc_comp_message_iknow'),
            type: 'warning'
          }
        );
        return;
      }
      setTimeout(() => {
        this.downReady();
      }, 500 * this.downFrequency);
    },
    // 获取下载任务状态
    downReady() {
      this.downFrequency++;
      getDownStatus(this.downTaskId)
        .then(res => {
          if (res.status === 9) {
            this.initData();
          } else {
            this.checkDownStatus();
          }
        })
        .catch(() => {
          this.checkDownStatus();
        });
    },
    initData() {
      this.timeout = 30;
      this.uuid = createUuid();
      saveMiliStartStatus({
        id: this.uuid,
        orgId: localStorage.orgId,
        userId: localStorage.userId,
        status: 0
      });
      this.openMili();
      this.checkStatus();
    },
    // 轮询检测唤起状态
    checkStatus() {
      let frequency = 0;
      this.alertable = false;
      this.timer = window.setInterval(() => {
        if (!browser.mac || browser.safari) {
          if (!document.hasFocus()) {
            this.alertable = true;
          }

          if (this.alertable) {
            if (frequency % 3 === 0) {
              setTimeout(() => {
                this.isReady();
              }, 0);
            }
            frequency += 1;
          }

          this.timeout -= 1;
        }

        if (browser.mac && !browser.safari) {
          if (!document.hasFocus()) {
            this.alertable = true;
            if (frequency % 3 === 0) {
              setTimeout(() => {
                this.isReady();
              }, 0);
            }
            frequency += 1;
          }

          if (document.hasFocus()) {
            this.timeout -= 1;
          }

          if (document.hasFocus() && this.alertable) {
            if (frequency % 3 === 0) {
              setTimeout(() => {
                this.isReady();
              }, 0);
            }
            frequency += 1;
          }
        }

        if (this.timeout <= 0) {
          this.callStatus = 'fail';
          this.timer && window.clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    isReady() {
      checkMiliStartStatus(this.uuid).then(res => {
        if (res.status) {
          this.timer && window.clearInterval(this.timer);
          this.timer = null;
          this.dialogVisible = false;
        }
      });
    },
    // 唤起米粒客户端
    openMili() {
      const param = {
        apiEnv,
        token: localStorage.token,
        lang: localStorage.yxtLang,
        orgId: localStorage.orgId,
        userId: localStorage.userId,
        uuid: this.uuid,
        page: this.page
      };

      // 上传参数
      if (this.page === 'upload') {
        param.uploadParam = {
          module: this.module
        };
      }
      // 下载参数
      if (this.page === 'download') {
        param.downloadParam = {
          module: this.module,
          downTime: this.openTime,
          downTaskId: this.downTaskId
        };
      }
      const url = `yxtdownload://index?data=${encodeURIComponent(
        JSON.stringify(param)
      )}`;
      openUriWithHiddenFrame(url);
    },
    macTip() {
      this.$confirm(
        this.$t('pc_biz_ddOpenDataTip').d(
          '抱歉，由于钉钉在Mac环境下无法呼起客户端，请使用Windows电脑开启米粒'
        ),
        this.$t('pc_biz_lbl_tip'),
        {
          confirmButtonText: this.$t('pc_comp_message_iknow'),
          type: 'warning'
        }
      );
    },
    // 下载米粒客户端
    handleDownload() {
      getMiliUrl(browser.mac ? 4 : 3).then(res => {
        res.appDownloadUrl && window.open(res.appDownloadUrl);
      });
    },
    // 取消
    handleCancel() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 重试
    handleRetry() {
      this.open('retry');
    }
  }
};
</script>
